import EventBus 		from "@/event-bus"
import sub_workspace1 	from "@/components/workspace/sub_workspaces.vue"
export default {
	name  : "sub_workspace",
	props : [
		"info_to_component",	
		"layout_id_component",
	],
	components : {
		sub_workspace1
	}, // components
	data  : () => ({

		info 				: {},
		info_comp 			: null,
		bus 				: {},
		state 				: "computer", 
		options 			: {
			errors : true
		},
		states 				: {} ,	
		loading 			: false,
		box_shadow_color 	: "", // 
		box_shadow  		: {
			color_error 	: "box-shadow: 0px 0px 1px 2px #ff5252;", // #F08080
			color_success 	: "box-shadow: 0px 0px 1px 2px #4caf50;", // #F08080
			
		},
		show 		: {
			no_signal : true,
		},
		colors_options 	: [
			{

				key  : "loading",
				text : "loading",
				color : "primary", 		
			},
			{
				key  : "good",
				text : "working",
				color : "success", 		
			},
			{
				key  : "restarting",
				text : "restarting",
				color : "warning", 		
			},
			{
				key  : "error",
				text : "error",
				color : "error", 		
			},
		],
	}), // data


	created(){
		if (this.info_to_component) {
			this.info_comp 	= this.info_to_component;
		} else {
			// Set default structure if no info_to_component is provided
			this.info_comp = {
				manager_id: "my_computer",
				name: "Default Computer"
			};
		}
		
		// Ensure manager_id exists
		if (!this.info_comp.manager_id) {
			this.info_comp.manager_id = "my_computer";
		}
		
		this.get_list();
		console.log("SUB_WORKSPACE CREATED - INFO COMP:", this.info_comp);
		
		/*if (this.render_sub_workspace && this.render_sub_workspace.list_workspaces && this.render_sub_workspace.list_workspaces[this.info_comp.manager]) {
			this.state 		= this.render_sub_workspace.list_workspaces[this.info_comp.manager].computer;//this.$store.state.Workspaces.list_workspaces[this.info_comp.manager]; //this.$Workspaces.get_status(this.info_comp.manager);
		}else{
			this.state 		= "computer";
		}*/
	}, // created



	computed : {
		render_sub_workspace: function(){
			// console.log("store : ", this.$store.getters["Workspaces/state_workspace"])
			// console.log("test", this.$store.state.Workspaces.list_workspaces this.info_comp.manager)//
			// let temp = this.$store.state.Workspaces; 
			// let list = {};
			// console.log("comp ****************** ", this.info_comp.manager_id, this.states)

			/*	if (this.state == "computer" && val.computer ) { // && list && list.computer 
					// console.log("pc : ", list.computer )
					this.state = val.computer//list.computer;
				}
			// if (this.$store.state.Workspaces && this.$store.state.Workspaces.list_workspaces && this.$store.state.Workspaces.list_workspaces[this.info_comp.manager_id]) {
				// list = this.$store.state.Workspaces.list_workspaces[this.info_comp.manager_id];				
			// console.log("charge 1")
			// }else 
			if(this.$store.state.Workspaces && this.$store.state.Workspaces.default && this.$store.state.Workspaces.default.my_computer){
				val = this.$store.state.Workspaces.default.my_computer;
				// list
			}*/
			// return list && list.states ? list.states : {};//this.$store.state.Workspaces ;//this.state.states;
			return this.states;// val && val.states ? val.states : {} 
		}, // render sub workspace

		
	},

	methods : {
		render_name(key, item){
			// console.log("RENDER NAMES --------_____> ", key, item)
			if (key.includes('network')) {
				return "Network"
			}else{
				if (item && item.name) {
					return item.name;
				}else{

					let temp = this.$Format.render_device(key);
					if (temp) {
						return (temp.name).toLowerCase();
					}else{
						return key.toLowerCase();
					}
				}

			}

		}, // render name

		get_list(){
			const api 	= this.$URL + "/api/v1/workspace/state";
			let info_up = { ...this.info_comp };
			
			// Debug: Log the info being sent
			console.log("INFO_COMP:", this.info_comp);
			console.log("INFO_UP being sent:", info_up);
			
			// Validate and set default manager_id if missing
			if (!info_up || !info_up.manager_id) {
				console.warn("Missing manager_id in workspace state request, using default 'my_computer'");
				if (!info_up) {
					info_up = {};
				}
				// Set default manager_id
				info_up.manager_id = "my_computer";
			}
			
			if (this.show.no_signal) {
				this.box_shadow_color  = this.box_shadow && this.box_shadow.color_error ? this.box_shadow.color_error : "";	
			}
			this.$axios.post(api, info_up).then(res => {
				if (res && res.data && !this.loading) {
					this.render_sub_workspace_states({...res.data})
				}
				this.loading = false;
			}).catch(er => {
				this.loading = false;
				console.log("Error get workspace state ", er)
			})
		}, // get list

		check_options(item){
			if (!this.options.errors) {
				return true;
			}else
			if (this.options.errors && item) {
				return true;
			}else{
				return false
			}

		}, // check options
		check_sub_options(item){
			if (!this.options.errors) {
				return true;
			}else
			if (this.options.errors && item && item.state && (item.state == 2 || item.state == 3)) {
				return true;
			}else{
				return false
			}
		}, //  check_sub_options
		start_bus(){
			if (this.info_comp && this.info_comp) {
				let vm 			= this;
				this.loading 	= true;
				// console.log("vm.info_comp.manager_id " , vm.info_comp.manager_id)
				let temp = 'states_workspace_' + vm.info_comp.manager_id;
				EventBus.$on(temp, vm.bus[temp] = (msg)=>{
					if (msg) {
						// console.log("states sub: ", vm.info_comp.manager_id, msg)
						// vm.render_sub_workspace({...msg})
						vm.render_sub_workspace_states({...msg})
						// vm.state = msg; //vm.$Workspaces.get_status(vm.info_comp.key);
						this.loading = false;

					}
				})
			}
		}, // start bus

		render_sub_workspace_states(val){
			// console.log("comp ****************** ", this.info_comp.manager_id, val)
			if (this.show.no_signal) {				
				this.show.no_signal 	= false;				
				this.box_shadow_color  	= this.box_shadow.color_success;
			}
			if (this.state == "computer" && val.computer ) { // && list && list.computer 
				// console.log("pc : ", list.computer )
				this.state = val.computer//list.computer;
			}
			if(!val && this.$store.state.Workspaces && this.$store.state.Workspaces.default && this.$store.state.Workspaces.default.my_computer){
				val = this.$store.state.Workspaces.default.my_computer;
				// list
			}
			this.states = val.states;
		}
	}, // methods
	mounted(){
		this.start_bus();
		
	}, // mounted

	beforeDestroy(){
		this.$Helper.clear_bus(EventBus, this.bus, "sub_workspace");
	}, // before destroy
};